import React, { useEffect, useState } from 'react'
import SparkApi from '../../api/SparkApi';
import { Doughnut, Pie } from 'react-chartjs-2';
import { ArcElement, Chart } from 'chart.js';
import { backgroundColors, random_rgba } from "../common/ChartColor";
import { Button } from 'react-bootstrap';
export default function DueAmountChart(props) {
    const { toDate, fromDate, setChartApi } = props;
    const [reportData, setReportData] = useState([]);
    const [data, setData] = useState({ labels: [], datasets: [{}] });
    Chart.register(
        ArcElement
    )

    async function fetchChartData() {
        const result = await SparkApi.fetchChartData({
            "apiName": "due_amount_chart",
            "filterColumn": null,
            "date": null,
            "isMonthWiseFilter": true
        });

        console.log("Api result", result);

        setReportData(result || []);
    }
    useEffect(() => {
        fetchChartData();
    }, []);

    // On props date change

    useEffect(() => {
        console.log("date selection", fromDate, toDate)
        const fetchChartData = async () => {
            const result = await SparkApi.fetchChartData({
                "apiName": "due_amount_chart",
                "filterColumn": null,
                "date": null,
                "isMonthWiseFilter": false,
                fromDate,
                toDate
            });
            console.log("APi result on from date & to date:- ", result);

            setReportData(result || []);

        }
        if (toDate && fromDate) fetchChartData();
    }, [toDate, fromDate]);

    const truncateLabel = (label) => {
        return label.length > 15 ? `${label.substring(0, 7)}...` : label;
    };
    useEffect(() => {
        // console.log("report data", reportData);
        if (reportData && reportData.length != 0) {
            const labels = reportData.map((rec) => (props.fullMode ? rec['Business Name'] : truncateLabel(rec['Business Name'])));
            const data = reportData.map((rec) => (rec['Due Amount']));
            // console.log(labels, data)

            const datasets = [{
                label: 'Due Amount',
                data: data,
                backgroundColor: backgroundColors,
                // backgroundColor: random_rgba(),

                hoverOffset: 4
            }];
            setData({ labels, datasets })
        }
        else {
            setData({ labels: [], datasets: [] });
        }
    }, [reportData]);

    return (
        <>
            {Array.isArray(reportData) && reportData.length != 0 ?
                <>
                    {setChartApi && <Button className='float-end' onClick={() => (setChartApi("due_amount_chart"))}>Full View</Button>}
                    <Pie data={data} />
                </>
                :

                <div style={{ minHeight: "81vh" }} className='d-flex align-items-center justify-content-center'>
                    <div>
                        <h1> No data</h1>
                    </div>
                </div>

            }
        </>
    )
}
